const tokenExpiration = {
  resetpassword: {
    jwt: "15m",
    label: "15 minutes",
  },
  verification: {
    jwt: "1d",
    label: "1 day",
  },
};

module.exports = tokenExpiration;
